<div class="container">
    <div class="row">
        <h4 class="title">{{ activity.name }}</h4>
    </div>
</div>